import { render, staticRenderFns } from "./PrepTaskBadges.vue?vue&type=template&id=cb4bc318&"
import script from "./PrepTaskBadges.vue?vue&type=script&lang=ts&"
export * from "./PrepTaskBadges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports